/* ==========================================================================
   ZPK — Popup newsletter all'atterraggio
   sections/zpk-newsletter-popup.liquid. Caricato dalla sezione con `defer`.
   Nessuna dipendenza, nemmeno da zpk-theme.js: le due utilita' $ / $$ e
   l'accesso protetto a sessionStorage sono ripetuti qui apposta, cosi' il
   popup non tocca il file condiviso del design system.
   ========================================================================== */
(function () {
  'use strict';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function safeSession(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') window.sessionStorage.setItem(key, value);
    } catch (e) { /* storage negato: si degrada senza rompere */ }
    return null;
  }

  /* --- Popup newsletter --------------------------------------------------
     sections/zpk-newsletter-popup.liquid. Si apre da solo all'atterraggio,
     ma solo dopo la scelta sul banner dei cookie: un <dialog> modale rende
     inerte tutto il resto della pagina, banner compreso, e il visitatore non
     potrebbe piu' rispondere al banner finche' non chiude il popup.
     Chi lo chiude non lo rivede per `data-days` giorni, chi si iscrive non
     lo rivede piu'. Il form 'customer' ricarica la pagina all'invio: lo stato
     «conferma» si riconosce da ?customer_posted=true e dall'ancora del form
     (o, se l'hCaptcha di Shopify l'ha persa per strada, da un segno lasciato
     in sessionStorage al momento dell'invio). */
  const NLPOP_SENT = 'zpk-nlpop-sent';
  const NLPOP_HASH = '#zpk-nlpop-form';

  // localStorage protetto: 'get' torna il valore (o null), 'set' e 'probe'
  // tornano 'ok', e ogni errore (navigazione privata, cookie bloccati) null.
  function safeLocal(action, key, value) {
    try {
      const store = window.localStorage;
      if (action === 'get') return store.getItem(key);
      if (action === 'set') { store.setItem(key, value); return 'ok'; }
      store.setItem('zpk-probe', '1');
      store.removeItem('zpk-probe');
      return 'ok';
    } catch (e) { return null; }
  }

  /* Si apre solo sulla pagina d'ingresso della visita, qualunque essa sia
     (Home, scheda prodotto aperta da Google, ...), mai passando da una
     pagina all'altra del sito. Pagina interna = si arriva dallo stesso sito,
     da un suo sottodominio (account.<dominio>) o da Shopify (area clienti e
     cassa ospitate su shopify.com). Senza referrer (indirizzo scritto a
     mano, segnalibro, app) conta il segno di visita in sessionStorage: se
     c'e' gia', la visita era cominciata prima. Va letto prima di scriverlo. */
  const NLPOP_VISIT = 'zpk-nlpop-visit';
  const NLPOP_LANDING = (function () {
    const visited = safeSession('get', NLPOP_VISIT) === '1';
    safeSession('set', NLPOP_VISIT, '1');
    let ref = null;
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) { ref = null; }
    if (!ref) return !visited;
    const site = (host) => host.split('.').slice(-2).join('.');
    if (ref.origin === window.location.origin || site(ref.hostname) === site(window.location.hostname)) return false;
    return !/(^|\.)(shopify\.com|shop\.app)$/.test(ref.hostname);
  })();

  function nlpopKey(host) { return 'zpk-nlpop-' + (host.dataset.campaign || '1'); }

  function nlpopRemember(host, state) {
    safeLocal('set', nlpopKey(host), JSON.stringify({ state, at: Date.now() }));
  }

  // true = non va aperto da solo. Senza storage non si puo' ricordare una
  // chiusura: meglio non aprirlo affatto che riaprirlo a ogni pagina.
  function nlpopSuppressed(host) {
    if (safeLocal('probe') === null) return true;
    const raw = safeLocal('get', nlpopKey(host));
    if (!raw) return false;
    let data = null;
    try { data = JSON.parse(raw); } catch (e) { return false; }
    if (!data) return false;
    if (data.state === 'subscribed') return true;
    const days = parseInt(host.dataset.days, 10) || 30;
    return data.state === 'closed' && Date.now() - Number(data.at || 0) < days * 864e5;
  }

  // Aspetta la scelta sul banner dei cookie di Shopify, se il banner va
  // mostrato a questo visitatore; altrimenti parte subito.
  function afterCookieChoice(run) {
    let done = false;
    const go = () => { if (!done) { done = true; run(); } };
    const S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') { go(); return; }
    // Rete di sicurezza: se l'API non risponde, non c'e' nemmeno il banner.
    const fallback = window.setTimeout(go, 10000);
    try {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        window.clearTimeout(fallback);
        const privacy = S.customerPrivacy;
        if (error || !privacy || typeof privacy.shouldShowBanner !== 'function' || !privacy.shouldShowBanner()) {
          go();
          return;
        }
        document.addEventListener('visitorConsentCollected', go, { once: true });
      });
    } catch (e) {
      window.clearTimeout(fallback);
      go();
    }
  }

  function nlpopCleanUrl() {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      if (url.hash === NLPOP_HASH) url.hash = '';
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) { /* URL invariato: al piu' un ricaricamento rimostra la conferma */ }
  }

  function nlpopOpen(host, which) {
    const dialog = $('[data-zpk-nlpop-dialog="' + which + '"]', host);
    if (!dialog || dialog.open) return;
    $$('dialog[open]', host).forEach((d) => d.close());
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    // Il fuoco va sul titolo e non sul primo comando: sul telefono, un fuoco
    // sul campo e-mail aprirebbe la tastiera appena atterrati.
    $('.zpk-nlpop__title', dialog)?.focus({ preventScroll: true });
  }

  // Col ritardo il popup puo' scattare mentre il visitatore sta facendo
  // altro. Non gli si toglie il fuoco mentre compila un modulo o scrive in un
  // campo (la ricerca, la newsletter della Home), ne' mentre e' dentro un
  // iframe (un video, una chat), e non si apre sopra un'altra finestra: un
  // <dialog> aperto, il menu mobile ZPK, un drawer del menu principale
  // (zpk-drawer.js), un popup di Xtra (plugin-popups.js mette `popup-shown`
  // su <html>). Si riprova ogni secondo.
  const NLPOP_TYPING = 'textarea, select, iframe, [contenteditable]:not([contenteditable="false"]), ' +
    'input:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="checkbox"])' +
    ':not([type="radio"]):not([type="range"]):not([type="color"]):not([type="file"]):not([type="image"])';

  function nlpopBusy(host) {
    const active = document.activeElement;
    if (active && active !== document.body && active !== document.documentElement && !host.contains(active) &&
        (active.closest('form') || active.matches(NLPOP_TYPING))) return true;
    if (document.documentElement.classList.contains('popup-shown')) return true;
    if ($('#zpk-mobile-menu.is-open, [data-zpk-drawer-item].is-open')) return true;
    return $$('dialog[open]').some((d) => !host.contains(d));
  }

  function nlpopOpenWhenIdle(host) {
    if (nlpopBusy(host)) {
      window.setTimeout(() => nlpopOpenWhenIdle(host), 1000);
      return;
    }
    nlpopOpen(host, 'form');
  }

  function initNewsletterPopup(root) {
    $$('[data-zpk-nlpop]', root).forEach((host) => {
      if (host.dataset.zpkBound) return;
      host.dataset.zpkBound = '1';
      const editor = Boolean(window.Shopify?.designMode);

      $$('dialog', host).forEach((dialog) => {
        // Clic sul fondo scuro: fuori dal riquadro della finestra.
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) {
            dialog.close();
          }
        });
        // Vale per ogni chiusura: X, «Chiudi», Esc, fondo scuro.
        dialog.addEventListener('close', () => {
          if (editor || dialog.dataset.zpkNlpopDialog !== 'form') return;
          if (!host.dataset.zpkSubscribed) nlpopRemember(host, 'closed');
        });
      });
      $$('[data-zpk-nlpop-close]', host).forEach((btn) => {
        btn.addEventListener('click', () => btn.closest('dialog')?.close());
      });
      $('form', host)?.addEventListener('submit', () => safeSession('set', NLPOP_SENT, '1'));

      // Nell'editor si apre solo selezionando la sezione (vedi in fondo).
      if (editor) return;

      const posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
      const mine = window.location.hash === NLPOP_HASH || safeSession('get', NLPOP_SENT) === '1';
      const status = host.dataset.status;

      if (mine && (posted || status === 'posted')) {
        safeSession('set', NLPOP_SENT, '');
        host.dataset.zpkSubscribed = '1';
        nlpopRemember(host, 'subscribed');
        nlpopCleanUrl();
        nlpopOpen(host, 'success');
        return;
      }
      if (mine && status === 'error') {
        safeSession('set', NLPOP_SENT, '');
        nlpopOpen(host, 'form');
        return;
      }
      // Iscritto da un altro modulo (la newsletter della Home): non va
      // disturbato di nuovo.
      if (posted) {
        host.dataset.zpkSubscribed = '1';
        nlpopRemember(host, 'subscribed');
        return;
      }
      if (!NLPOP_LANDING || host.dataset.auto !== 'true' || host.dataset.subscribed === 'true' || nlpopSuppressed(host)) return;

      // Il ritardo conta dall'inizio del caricamento della pagina
      // (performance.now()). Se la scelta sui cookie arriva dopo, il popup
      // si apre subito dopo la scelta.
      const delay = Math.max(0, parseInt(host.dataset.delay, 10) || 0) * 1000;
      afterCookieChoice(() => {
        const wait = Math.max(0, delay - (window.performance ? window.performance.now() : 0));
        window.setTimeout(() => nlpopOpenWhenIdle(host), wait);
      });
    });
  }

  function nlpopHostFor(event) {
    const id = event.detail?.sectionId;
    if (!id) return null;
    return document.querySelector('[data-zpk-nlpop="' + (window.CSS?.escape ? CSS.escape(id) : id) + '"]');
  }

  /* --- Avvio ------------------------------------------------------------- */
  // Con `defer` il DOM e' gia' analizzato quando lo script gira.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initNewsletterPopup(document));
  } else {
    initNewsletterPopup(document);
  }

  // Theme editor: rirender della sezione, e apertura solo quando la sezione e'
  // selezionata, nello stato scelto in «Stato mostrato nell'editor». Dopo un
  // rirender l'editor rimanda il select.
  document.addEventListener('shopify:section:load', (event) => initNewsletterPopup(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const host = nlpopHostFor(event);
    if (host) nlpopOpen(host, host.dataset.preview === 'success' ? 'success' : 'form');
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    const host = nlpopHostFor(event);
    if (host) $$('dialog[open]', host).forEach((d) => d.close());
  });
})();
